import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { POLLING_INTERVAL } from "./pollingInterval";

export const Injected = new InjectedConnector({
	supportedChainIds: [
		1, // Mainet
		3, // Ropsten
		4, // Rinkeby
		5, // Goerli
		42, // Kovan
		1337, // dev
		11155111, // sepolia
	],
});

export const WalletConnect = new WalletConnectConnector({
	rpc: {
		1: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
		3: `https://ropsten.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
		4: `https://rinkeby.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
		5: `https://goerli.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
		42: `https://kovan.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
		11155111: `https://sepolia.infura.io/v3/${process.env.REACT_APP_INFURA_ID}`,
	},
	qrcode: true,
	bridge: "https://bridge.walletconnect.org",
	pollingInterval: POLLING_INTERVAL,
});
